<script>
import Modal from '@/components/Modal'
import ModalHeader from '@/components/ModalHeader'
import Action from '@/components/Action'
import Icon from '@/components/Icon'
import ContentLoading from '@/components/ContentLoading'

export default {
  name: 'ModalConfirmationPecas',

  components: {
    Modal,
    ModalHeader,
    Action,
    Icon,
    ContentLoading,
  },

  props: {
    defaultTitle: {
      type: String,
      default: 'Produto indisponível ou não cadastrado',
    },
    defaultMessage: {
      type: String,
      default: 'Este produto não está disponível para adicionar ao carrinho.',
    },
    defaultMessageSubline: {
      type: String,
      default: 'Tem certeza que deseja continuar ?',
    },
  },

  data () {
    return {
      isVisible: false,
      loading: false,
      resolvePromise: null,
      products: [],
      title: '',
      message: '',
      messageSubline: '',
    }
  },

  methods: {
    show (options = {}) {
      if (options.product) {
        this.products = [options.product]
      } else if (Array.isArray(options.products)) {
        this.products = options.products
      } else {
        this.products = []
      }

      this.title = options.title ?? this.defaultTitle
      this.message = options.message ?? this.defaultMessage
      this.messageSubline = options.messageSubline ?? this.defaultMessageSubline

      this.isVisible = true
      return new Promise((resolve) => {
        this.resolvePromise = resolve
      })
    },

    handleResponse (response) {
      this.isVisible = false
      if (this.resolvePromise) {
        this.resolvePromise(response)
      }
    },

    closeModal () {
      this.handleResponse(false)
    },
  },

}
</script>

<template>
  <modal :active="isVisible" @close="handleResponse(false)" :close="false" :class="$classes['modal']">
    <template v-if="isVisible">
      <modal-header :title="title" />
      <content-loading v-if="isVisible && loading" :height="'100px'" />
      <div v-else>
        <div v-if="products.length" :class="$classes['product-list']">
          <div v-for="(item, index) in products" :key="item.product_id || index" :class="$classes['product-card']">
            <div :class="$classes['product-main-info']">
              <div :class="$classes['product-code']">Código: {{ item.product_id }}</div>
              <div :class="$classes['product-description']">{{ item.description }}</div>
            </div>
          </div>
        </div>
        <div :class="$classes['message-container']">
          <span :class="$classes['message']">{{ message }}</span>
          <span :class="$classes['message-subline']">{{ messageSubline }}</span>
        </div>
        <div :class="$classes['actions']">
          <action variant="flat" color="secondary" uppercase bold @click="handleResponse(false)">
            <icon v-if="!$media.mobile" name="long-arrow-alt-left" btnIcon />
            Cancelar
          </action>
          <action variant="contained" color="primary" :loading="loading" :disabled="loading"
            @click="handleResponse(true)">
            Confirmar
          </action>
        </div>
      </div>
    </template>
  </modal>
</template>

<style module>
.modal {
  z-index: 101;
}

.product-list {
  height: auto;
  min-height: 200px;
  max-height: 60vh;
  overflow-y: auto;
  margin-bottom: 20px;
}

.product-card {
  margin-bottom: 12px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  background: #fff;
}

.product-card:last-child {
  margin-bottom: 0;
}

.product-main-info {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.product-code {
  font-size: 14px;
  color: #6c757d;
  font-family: monospace;
}

.product-description {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}

.message {
  margin-top: 10px;
  font-size: 14px;
  color: #292929;
}

.message-bold {
  font-size: 16px;
  font-weight: bold;
  color: rgba(41, 41, 41, 0.8);
}

.message-subline {
  font-weight: 500;
  margin-top: 10px;
  font-size: 14px;
  color: #292929;
}

.message-container {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1.2px;
  color: rgba(41, 41, 41, 0.8);
  line-height: 20px;
  margin-bottom: 10px;
}

.actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media (max-width: 768px) {
  .product-card {
    margin-bottom: 8px;
  }

  .product-main-info {
    padding: 16px;
    gap: 6px;
  }

  .product-description {
    font-size: 13px;
  }

  .product-code {
    font-size: 12px;
  }
}
</style>
